import * as React from "react";
const SvgHome = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "inherit", d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" }));
export default SvgHome;
